<template>
	<div class="partial partial--banners banners">
		<div class="partial__heading">
			<ion-icon name="cloud-offline" size="large" class="partial__icon"></ion-icon>
			<h1 class="partial__title">Registration Blacklist</h1>


			<div class="partial__actions">
				<router-link :to="{name: 'domain' }" class="button">
					<div class="mdc-button__ripple"></div>
					<ion-icon name="add-circle-outline" class="mdc-button__icon" aria-hidden="true"></ion-icon>
					<span class="mdc-button__label">Add Domain</span>
				</router-link>
			</div>
		</div>

		<div class="partial__body registrations__body">
			<list-domains :domains="domains" :loading="loading" />
			<!-- <pagination :limit="limit" :count="regCount" /> -->
		</div>

		<modal @close="hideModal" :open="modalVisible" :title="modalTitle">
			<router-view class="main__modal" slot="content" name="pageModal" />
		</modal>
	</div>
</template>

<script>
import Modal from '@/components/Modal'
import ListDomains from '@/components/ListDomains'

export default {
	name: 'PartialBlacklist',
	components: {
		ListDomains,
		Modal,
	},
	metaInfo: () => ({
		title: 'Blacklist',
	}),
	async mounted() {
		await this.$store.dispatch('blacklist/list')
	},
	computed: {
		domains() {
			return this.$store.getters['blacklist/domains']
		},
		loading() {
			return this.$store.getters['misc/loading']
		},
		modalVisible() {
			return this.$route.name == 'domain'
		},
		modalTitle() {
			return this.$route.meta.modalTitle
		},
	},
	methods: {
		hideModal(clicked) {
			this.$router.replace({ name: 'blacklist' })
		},
	},
}
</script>

<style scoped lang="scss">
</style>
